export default "__VITE_ASSET__aecc8b03__"